import { Card, Checkbox, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { DangerLinearProgress, InactiveLinearProgress, SuccessLinearProgress, WarningLinearProgress } from './LinearProgress.styles';

interface ComplianceCounts {
  actionRequired: number;
  actionRequiredPercentage: number;
  attentionNeeded: number;
  attentionNeededPercentage: number;
  upToDate: number;
  upToDatePercentage: number;
  inactive: number;
  inactivePercentage: number;
}

type Props = {
  complianceFilter: number | undefined;
  complianceCounts: ComplianceCounts;
  handleComplianceFilter: (value: number) => void;
  loading: boolean;
};

const ComplianceStatus = ({ complianceFilter, complianceCounts, handleComplianceFilter, loading }: Props) => {
  return (
    <Card variant="outlined" className="m-r-25 flex-1">
      <div className="box-header">Compliance Status</div>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: '10%' }}>Practices</TableCell>
            <TableCell sx={{ width: '30%' }}></TableCell>
            <TableCell sx={{ width: '40%' }}>Status</TableCell>
            <TableCell sx={{ width: '20%' }}>Filter by</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {!loading && (
              <>
                <TableCell>
                  <span className="compliance-box background-danger">{complianceCounts.actionRequired}</span>
                </TableCell>
                <TableCell>
                  <DangerLinearProgress variant="determinate" value={complianceCounts.actionRequiredPercentage} />
                </TableCell>
              </>
            )}
            {loading && (
              <>
                <TableCell>
                  <Skeleton variant="rounded" width={24} height={23} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" height={8}></Skeleton>
                </TableCell>
              </>
            )}
            <TableCell>Action Required</TableCell>
            <TableCell>
              <Checkbox value={3} checked={complianceFilter === 3 ? true : false} onChange={() => handleComplianceFilter(3)} />
            </TableCell>
          </TableRow>
          <TableRow>
            {!loading && (
              <>
                <TableCell>
                  <span className="compliance-box background-warning">{complianceCounts.attentionNeeded}</span>
                </TableCell>
                <TableCell>
                  <WarningLinearProgress variant="determinate" value={complianceCounts.attentionNeededPercentage} />
                </TableCell>
              </>
            )}
            {loading && (
              <>
                <TableCell>
                  <Skeleton variant="rounded" width={24} height={23} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" height={8}></Skeleton>
                </TableCell>
              </>
            )}
            <TableCell>Attention Needed</TableCell>
            <TableCell>
              <Checkbox value={2} checked={complianceFilter === 2 ? true : false} onChange={() => handleComplianceFilter(2)} />
            </TableCell>
          </TableRow>
          <TableRow>
            {!loading && (
              <>
                <TableCell>
                  <span className="compliance-box background-success">{complianceCounts.upToDate}</span>
                </TableCell>
                <TableCell>
                  <SuccessLinearProgress variant="determinate" value={complianceCounts.upToDatePercentage} />
                </TableCell>
              </>
            )}
            {loading && (
              <>
                <TableCell>
                  <Skeleton variant="rounded" width={24} height={23} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" height={8}></Skeleton>
                </TableCell>
              </>
            )}
            <TableCell>Up to Date</TableCell>
            <TableCell>
              <Checkbox value={1} checked={complianceFilter === 1 ? true : false} onChange={() => handleComplianceFilter(1)} />
            </TableCell>
          </TableRow>
          <TableRow>
            {!loading && (
              <>
                <TableCell>
                  <span className="compliance-box background-inactive">{complianceCounts.inactive}</span>
                </TableCell>
                <TableCell>
                  <InactiveLinearProgress variant="determinate" value={complianceCounts.inactivePercentage} />
                </TableCell>
              </>
            )}
            {loading && (
              <>
                <TableCell>
                  <Skeleton variant="rounded" width={24} height={23} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" height={8}></Skeleton>
                </TableCell>
              </>
            )}
            <TableCell>Service Inactive</TableCell>
            <TableCell>
              <Checkbox value={4} checked={complianceFilter === 4 ? true : false} onChange={() => handleComplianceFilter(4)} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};

export default ComplianceStatus;
